import React, { useState, useEffect } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { json } from '@codemirror/lang-json';

export default function JsonEditor({ value = '{}', onChange, disabled }) {
  const [jsonText, setJsonText] = useState(value);
  const [error, setError] = useState(null);

  useEffect(() => {
    setJsonText(value);
  }, [value]);

  const handleChange = (val) => {
    if (val == "") {
      setError(null);
    }
    setJsonText(val);
    try {
      const parsed = JSON.parse(val);
      setError(null);
      onChange && onChange(parsed); // Notify parent with parsed JSON
    } catch (e) {
      if (val != "") {
        setError('Invalid JSON: ' + e.message);
      }
      // Notify parent that JSON is invalid
    }
  };

  return (
    <div style={{ fontFamily: 'sans-serif', maxWidth: '800px', margin: '0 auto' }}>
      <CodeMirror
        value={jsonText}
        height="300px"
        extensions={[json()]}
        onChange={handleChange}
        theme="light"
        readOnly={disabled}
        editable={!disabled}
      />

      <div style={{ marginTop: '5px', fontSize: '0.9rem' }}>
        {error ? (
          <span style={{ color: 'red' }}>❌</span>
        ) : (
          //   <span style={{ color: 'green' }}>✅</span>
          ""
        )}
      </div>
    </div>
  );
}
